export const buildQueryParam = (token?: string | null, creativeSource?: string): string => {
  if (token && creativeSource) {
    return `?token=${token}&creative_source=${creativeSource}`;
  }
  if (token) {
    return `?token=${token}`;
  }
  if (creativeSource) {
    return `?creative_source=${creativeSource}`;
  }
  return '';
};
